import React from 'react';
import { Check, X, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { fmtGameDate, fmtGameTime } from '@/lib/officialsApi';
import { AssignmentStatusBadge } from '../StatusPill';

export const AssignmentCard = ({ a, onRespond, muted }) => {
  const g = a.game || {};
  const canAct = onRespond && ['pending', 'accepted'].includes(a.status);
  return (
    <div className={`bg-white border rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row gap-4 ${muted ? 'opacity-70' : ''} ${a.status === 'pending' ? 'border-amber-300 shadow-sm' : ''}`}
      data-testid={`portal-assignment-${a.id}`}>
      <div className="sm:w-28 shrink-0 rounded-xl bg-[#00247D] text-white px-3 py-2 text-center flex sm:flex-col items-center sm:justify-center gap-2 sm:gap-0">
        <div className="text-[11px] uppercase font-bold text-white/70">{fmtGameDate(g.date)}</div>
        <div className="text-xl font-black leading-tight" style={{ fontFamily: 'Barlow Condensed' }}>{fmtGameTime(g.time)}</div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs font-bold uppercase tracking-wide text-[#CF142B]">{a.role_label}</span>
          <AssignmentStatusBadge status={a.status} testId={`portal-assignment-status-${a.id}`} />
        </div>
        <div className={`font-bold text-slate-900 text-lg leading-tight mt-1 ${a.status === 'cancelled' ? 'line-through' : ''}`}>{g.team_a_name} vs {g.team_b_name}</div>
        <div className="text-sm text-slate-500 flex items-center gap-1 mt-0.5">
          <MapPin className="w-3.5 h-3.5 shrink-0" /><span className="truncate">{[g.venue || 'Venue TBD', g.court && `Court ${g.court}`].filter(Boolean).join(' · ')}</span>
        </div>
        <div className="text-xs text-slate-400 mt-0.5">{[g.event_name, a.org_name].filter(Boolean).join(' · ')}</div>
        {a.instructions && <div className="mt-2 text-sm bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 text-amber-900">{a.instructions}</div>}
        {a.status === 'cancelled' && a.cancel_reason && <div className="mt-2 text-xs text-slate-500">Reason: {a.cancel_reason}</div>}
      </div>
      {canAct && (
        <div className="flex sm:flex-col gap-2 sm:w-36 shrink-0 sm:justify-center">
          {a.status === 'pending' && (
            <Button className="flex-1 sm:flex-none bg-emerald-600 hover:bg-emerald-700" onClick={() => onRespond(a, 'accept')} data-testid={`portal-accept-${a.id}`}>
              <Check className="w-4 h-4 mr-1.5" />Accept
            </Button>
          )}
          <Button variant="outline" className="flex-1 sm:flex-none text-red-600 border-red-200 hover:bg-red-50" onClick={() => onRespond(a, 'decline')} data-testid={`portal-decline-${a.id}`}>
            <X className="w-4 h-4 mr-1.5" />{a.status === 'accepted' ? "Can't make it" : 'Decline'}
          </Button>
        </div>
      )}
    </div>
  );
};
